<div class="container">
    <div style="margin-top: 15%; margin-bottom: 10%;">
        <h1 align="center">❗⚠ 404 Error ⚠❗</h1>
        <h4 align="center">😣OPPS Page Not Found😥</h4>
    </div>
</div>